
import React from 'react';
import { ShieldX } from 'lucide-react';

interface TradingSuspendedModalProps {
    onClose: () => void;
}

const TradingSuspendedModal: React.FC<TradingSuspendedModalProps> = ({ onClose }) => {
    return (
        <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4 animate-in fade-in duration-200">
            <div className="w-full max-w-sm bg-white dark:bg-slate-900 rounded-3xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300 border border-red-200 dark:border-red-500/30">
                {/* 상단 경고 바 */}
                <div className="h-2 w-full bg-gradient-to-r from-red-500 to-rose-600" />

                <div className="p-8 flex flex-col items-center gap-5">
                    {/* 아이콘 */}
                    <div className="w-20 h-20 rounded-full bg-red-50 dark:bg-red-500/10 flex items-center justify-center border-2 border-red-100 dark:border-red-500/20">
                        <ShieldX className="w-10 h-10 text-red-500" />
                    </div>

                    {/* 제목 */}
                    <div className="text-center space-y-2">
                        <h2 className="text-2xl font-black text-slate-900 dark:text-white tracking-tight">
                            거래 정지
                        </h2>
                        <p className="text-sm font-bold text-slate-500 dark:text-slate-400">
                            Trading Suspended
                        </p>
                    </div>

                    {/* 안내 메시지 */}
                    <div className="w-full bg-red-50 dark:bg-red-500/10 rounded-2xl p-5 text-center border border-red-100 dark:border-red-500/20">
                        <p className="text-base font-black text-red-600 dark:text-red-400 leading-relaxed">
                            현재 계정의 모든 거래가 정지되었습니다.
                        </p>
                        <p className="text-sm font-bold text-red-500/80 dark:text-red-400/70 mt-2 leading-relaxed">
                            스왑, 데이트레딩 등 모든 거래는<br />
                            정지 기간 동안 이용이 불가능합니다.
                        </p>
                        <div className="mt-4 pt-4 border-t border-red-200 dark:border-red-500/20">
                            <p className="text-sm font-black text-slate-700 dark:text-slate-300">
                                거래정지 해제 후 이용해주세요.
                            </p>
                        </div>
                    </div>

                    {/* 안내 텍스트 */}
                    <p className="text-xs font-bold text-slate-400 dark:text-slate-500 text-center">
                        자세한 사항은 고객센터에 문의하시기 바랍니다.
                    </p>

                    {/* 확인 버튼 */}
                    <button
                        onClick={onClose}
                        className="w-full py-4 rounded-2xl bg-slate-900 dark:bg-slate-700 text-white font-black text-sm uppercase tracking-widest hover:bg-slate-700 dark:hover:bg-slate-600 active:scale-95 transition-all shadow-lg"
                    >
                        확인
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TradingSuspendedModal;
